import React, { useEffect, useState } from "react";

import AppsContainer from "../../../@crema/core/AppsContainer";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  getProfessionalProfile,
  setSearch,
  setPage,
  setSortBy,
  setOrderBy,
} from "redux/actions/ProfessionalProfile";
import AppsHeader from "../../../@crema/core/AppsContainer/AppsHeader";
import AppsContent from "../../../@crema/core/AppsContainer/AppsContent";
import AppsPagination from "../../../@crema/core/AppsPagination";
import AppInfoView from "../../../@crema/core/AppInfoView";
import { Input, Button, Modal, Typography, message } from "antd";
import "./index.style.less";
import AppPageMetadata from "../../../@crema/core/AppPageMetadata";
import ProfessionalProfileTable from "./ProfessionalProfileTable";
import AddProfessionalProfile from "./AddProfessionalProfile";
import { usePermissions } from "lib/permissionHook";
import ModalCloseConfirm from "lib/components/ModalCloseConfirm";
import { AppLoader } from "@crema";
import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";
import { DownloadOutlined } from "@ant-design/icons";
import AwesomeDebouncePromise from "awesome-debounce-promise";

const debounceSearchOrder = AwesomeDebouncePromise(
  (search, dispatch) => {
    dispatch(setSearch(search));
    dispatch(setPage(1));
  },
  500,
  {
    onlyResolvesLast: true,
  }
);

const MODULE_NAME = "PROFESSIONAL PROFILE";

function ProfessionalProfile() {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const {
    professionalProfile,
    professionalProfileCount,
    page,
    search,
    sortby,
    orderby,
  } = useSelector(({ professionalProfile }) => professionalProfile);
  const { loading } = useSelector(({ common }) => common);
  const [loader, setLoader] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const { profile } = useSelector(({ profile }) => profile);
  const permission = usePermissions(MODULE_NAME, profile);

  const onChange = (page) => {
    dispatch(setPage(page));
  };
  useEffect(() => {
    dispatch(getProfessionalProfile());
  }, [dispatch, search, page, sortby, orderby]);

  const onSearchOrder = (e) => {
    debounceSearchOrder(e.target.value, dispatch);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleExport = () => {
    setLoader(true);
    const payload = {
      moduleName: "PROFESSIONAL_PROFILE",
      search: search,
    };
    jwtAxios
      .post("/common/download-excel-data", payload)
      .then((response) => {
        setLoader(false);
        if (response.status === 200) {
          const csvUrl = response.data.data.url;
          const a = document.createElement("a");
          a.href = csvUrl;
          a.download = csvUrl.split("/").pop();
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          message.success("Successfully downloaded!");
        } else {
          message.error("Something went wrong!");
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
        message.error(
          error.response?.data.msg ? error.response?.data.msg : error.message
        );
      });
  };
  const handleSortChange = (...sorterChange) => {
    const sorter = sorterChange.find((item) => item.order);
    if (sorter) {
      dispatch(
        setSortBy(
          sorter.field === "updatedAtFormatted" ? "createdAt" : sorter.field
        )
      );
      dispatch(setOrderBy(sorter.order === "ascend" ? "asc" : "desc"));
      dispatch(setPage(1));
    }
  };
  useEffect(() => {
    return () => {
      dispatch(setPage(1));
      dispatch(setSearch(""));
    };
  }, []);

  return (
    <>
      <AppPageMetadata title="Professional Profile" />
      <AppsContainer
        title={messages["sidebar.admin.professional-profile"]}
        fullView
        type="bottom"
      >
        <AppsHeader key={"wrap"}>
          <div className="customer-header">
            <div className="customer-header-input-view">
              <Input
                id="user-name"
                placeholder="Search"
                type="search"
                onChange={onSearchOrder}
              />
            </div>
            <Typography style={{ padding: "0 0.5rem" }}>
              Total: {professionalProfileCount}
            </Typography>
            <div className="customer-header-right">
              <Button
                type="primary"
                shape="round"
                icon={<DownloadOutlined />}
                onClick={handleExport}
                disabled={professionalProfile.length < 1}
              >
                Export
              </Button>
              <Button
                type="primary"
                onClick={showModal}
                disabled={
                  permission && !permission.delete && !profile.isSuperAdmin
                }
              >
                Add Professional Profile
              </Button>

              <AppsPagination
                className="customer-header-pagination"
                pageSize={10}
                current={page}
                count={professionalProfileCount}
                page={page}
                onChange={onChange}
              />
            </div>
          </div>
        </AppsHeader>

        <AppsContent
          key={"wrap1"}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          <ProfessionalProfileTable
            loading={loading}
            professionalProfile={professionalProfile}
            handleSortChange={handleSortChange}
          />
        </AppsContent>

        <AppsPagination
          key={"wrap2"}
          className="customer-footer-pagination"
          pageSize={10}
          current={page}
          count={professionalProfileCount}
          page={page}
          onChange={onChange}
        />
      </AppsContainer>

      <Modal
        title={messages["admin.addProfessionalProfile"]}
        visible={isModalVisible}
        onOk={handleOk}
        footer={false}
        maskClosable={false}
        destroyOnClose={true}
        closeIcon={<ModalCloseConfirm onCancel={handleCancel} />}
      >
        <AddProfessionalProfile closeModel={handleCancel} />
      </Modal>

      <AppInfoView />
      {loader ? <AppLoader /> : null}
    </>
  );
}

export default ProfessionalProfile;
